import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  ngOnInit(): void {
    this.initializeApp();
  }

  ngAfterViewInit(): void {
    // After view initialization logic here
  }

  private initializeApp(): void {
    // Initialization logic here
  }
}
